import React from "react";
import PropTypes from "prop-types";
import {
  MdClose,
  MdMedicalServices,
  MdPersonPin,
  MdPeople,
  MdEmail,
  MdPhone,
} from "react-icons/md";

const ServiceDetails = ({ service, onClose, getPhotoUrl }) => {
  const getStatusService = (service) => {
    if (service.chefService && service.major && service.members?.length > 0) {
      return "Complet";
    } else if (service.chefService || service.major) {
      return "Partiel";
    } else {
      return "En attente";
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Complet":
        return "bg-green-500";
      case "Partiel":
        return "bg-yellow-500";
      case "En attente":
        return "bg-red-500";
      default:
        return "bg-gray-500";
    }
  };

  const status = getStatusService(service);
  const statusColorClass = getStatusColor(status);

  return (
    <div>
      {/* En-tête */}
      <div className="mb-6 flex items-center justify-between border-b border-gray-200 pb-4">
        <h2 className="text-2xl font-bold text-[#333333]">
          Détails du service
        </h2>
        <button
          onClick={onClose}
          className="rounded-full bg-gray-200 p-1 text-gray-500 transition-colors hover:bg-gray-300"
          aria-label="Fermer"
        >
          <MdClose size={20} />
        </button>
      </div>

      {/* Image et informations principales */}
      <div className="mb-6 grid grid-cols-1 gap-6 md:grid-cols-2">
        {/* Image */}
        <div className="overflow-hidden rounded-lg">
          {service.photo ? (
            <img
              src={getPhotoUrl(service.photo)}
              alt={service.nom}
              className="h-64 w-full object-cover"
            />
          ) : (
            <div className="flex h-64 items-center justify-center bg-gradient-to-br from-[#2ca01c]/10 to-[#7028a9]/10">
              <MdMedicalServices className="text-8xl text-[#2ca01c]/40" />
            </div>
          )}
        </div>

        {/* Informations principales */}
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h3 className="text-2xl font-bold text-[#333333]">{service.nom}</h3>
            <span
              className={`rounded-full ${statusColorClass} px-3 py-1 text-sm font-medium text-white`}
            >
              {status}
            </span>
          </div>

          <div className="space-y-3">
            <div className="flex items-center text-gray-700">
              <MdMedicalServices className="mr-3 text-xl text-[#7028a9]" />
              <div>
                <span className="font-semibold">Pathologie:</span>
                <span className="ml-2">{service.pathologie}</span>
              </div>
            </div>

            {service.description && (
              <div className="rounded-lg bg-[#f9f9f9] p-4">
                <h4 className="mb-2 font-semibold text-gray-800">
                  Description:
                </h4>
                <p className="text-gray-700">{service.description}</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Personnel médical */}
      <div className="space-y-6">
        {/* Chef de service */}
        {service.chefService && (
          <div className="rounded-lg bg-green-50 p-4">
            <h4 className="mb-3 flex items-center text-lg font-semibold text-green-800">
              <MdPersonPin className="mr-2 text-xl" />
              Chef de service
            </h4>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <p className="font-semibold text-gray-800">
                  {service.chefService.titre} {service.chefService.name}
                </p>
                <p className="text-gray-600">
                  {service.chefService.specialization}
                </p>
              </div>
              <div className="space-y-1">
                {service.chefService.email && (
                  <p className="flex items-center text-gray-600">
                    <MdEmail className="mr-2 text-green-600" />
                    {service.chefService.email}
                  </p>
                )}
                {service.chefService.phone && (
                  <p className="flex items-center text-gray-600">
                    <MdPhone className="mr-2 text-green-600" />
                    {service.chefService.phone}
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Major */}
        {service.major && (
          <div className="rounded-lg bg-blue-50 p-4">
            <h4 className="mb-3 flex items-center text-lg font-semibold text-blue-800">
              <MdPersonPin className="mr-2 text-xl" />
              Major
            </h4>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <p className="font-semibold text-gray-800">
                  {service.major.titre} {service.major.name}
                </p>
                <p className="text-gray-600">{service.major.specialization}</p>
              </div>
              <div className="space-y-1">
                {service.major.email && (
                  <p className="flex items-center text-gray-600">
                    <MdEmail className="mr-2 text-blue-600" />
                    {service.major.email}
                  </p>
                )}
                {service.major.phone && (
                  <p className="flex items-center text-gray-600">
                    <MdPhone className="mr-2 text-blue-600" />
                    {service.major.phone}
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Membres de l'équipe 
        {service.members && service.members.length > 0 && (
          <div className="rounded-lg bg-purple-50 p-4">
            <h4 className="mb-3 flex items-center text-lg font-semibold text-purple-800">
              <MdPeople className="mr-2 text-xl" />
              Équipe médicale ({service.members.length} membre
              {service.members.length > 1 ? "s" : ""})
            </h4>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
              {service.members.map((member, index) => (
                <div key={index} className="rounded-lg bg-white p-3 shadow-sm">
                  <p className="font-semibold text-gray-800">
                    {member.titre} {member.name}
                  </p>
                  <p className="text-sm text-gray-600">
                    {member.specialization}
                  </p>
                  {member.email && (
                    <p className="mt-1 flex items-center text-sm text-gray-600">
                      <MdEmail className="mr-1 text-purple-600" />
                      {member.email}
                    </p>
                  )}
                  {member.phone && (
                    <p className="flex items-center text-sm text-gray-600">
                      <MdPhone className="mr-1 text-purple-600" />
                      {member.phone}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        */}

        {/* Message si aucun personnel assigné */}
        {!service.chefService &&
          !service.major &&
          (!service.members || service.members.length === 0) && (
            <div className="rounded-lg bg-yellow-50 p-4 text-center">
              <MdPeople className="mx-auto mb-2 text-4xl text-yellow-600" />
              <p className="text-yellow-800">
                Aucun personnel médical n'est encore assigné à ce service.
              </p>
            </div>
          )}
      </div>
    </div>
  );
};
ServiceDetails.propTypes = {
  service: PropTypes.shape({
    photo: PropTypes.string,
    nom: PropTypes.string,
    pathologie: PropTypes.string,
    description: PropTypes.string,
    chefService: PropTypes.shape({
      titre: PropTypes.string,
      name: PropTypes.string,
      specialization: PropTypes.string,
      email: PropTypes.string,
      phone: PropTypes.string,
    }),
    major: PropTypes.shape({
      titre: PropTypes.string,
      name: PropTypes.string,
      specialization: PropTypes.string,
      email: PropTypes.string,
      phone: PropTypes.string,
    }),
    members: PropTypes.arrayOf(
      PropTypes.shape({
        titre: PropTypes.string,
        name: PropTypes.string,
        specialization: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
      })
    ),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  getPhotoUrl: PropTypes.func.isRequired,
};

export default ServiceDetails;
